import { Component, Input } from '@angular/core';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';

@Component({
  selector: 'app-image-rendered',
  templateUrl: './image-rendered.component.html',
  styleUrls: ['./image-rendered.component.css']
})
export class ImageRenderedComponent extends ElementComponent {
  @Input()
  public override data: any = {}
  // https://stackoverflow.com/questions/63539847/is-there-a-way-to-bind-to-an-array-of-components-in-angular-and-render-those-in

  public viewerOptions: any = {
    navbar: false,
    movable: true,
    toolbar: {
      zoomIn: 1,
      zoomOut: 1,
      reset: 1,
      rotateLeft: 1,
      rotateRight: 1,
    }
  };

  onViewed(event: any): void {
    const viewer = event?.target?.viewer;
    if (!viewer) return;
    viewer.zoomTo(1.25);
  }

}
